import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/shared/api/apiClient";
import { useAuth } from "@/shared/hooks/useAuth";
import type { MySchoolsResponse } from "@/shared/api/types";

/**
 * Çoklu-okul "Okullarım" genel bakışı — Dashboard bölümü ile AppShell okul değiştiricisi aynı cache'i
 * paylaşır (tek fetch). Muhasebeci uca erişemez (guard SCHOOL_ADMIN|GUIDANCE_COUNSELOR) → enabled koşulu
 * aynı rollerle sınırlı. Tek okullu kullanıcıda 1 eleman döner; tüketiciler length >= 2 ile gizler.
 */
export const useMySchools = () => {
  const { hasAnyRole } = useAuth();
  return useQuery({
    queryKey: ["my-schools"],
    enabled: hasAnyRole(["SCHOOL_ADMIN", "GUIDANCE_COUNSELOR"]),
    queryFn: async () => {
      const { data } = await apiClient.get<MySchoolsResponse>("/school-admin/my-schools");
      return data;
    },
  });
};
